/* global AbortController, HTMLElement */

export class ThreeDContentSwitch extends HTMLElement {
  connectedCallback() {
    this.disconnectedCallback()

    this.abortController = new AbortController()
    this.controls = [...this.querySelectorAll('[data-switch-control]')]
    this.panels = [...this.querySelectorAll('[data-switch-panel]')]
    if (!this.controls.length) return

    for (const control of this.controls) {
      control.addEventListener('click', this.handleClick, {
        signal: this.abortController.signal,
      })
      control.addEventListener('keydown', this.handleKeydown, {
        signal: this.abortController.signal,
      })
    }

    this.addEventListener('shopify:block:select', this.handleBlockSelect, {
      signal: this.abortController.signal,
    })
    this.select(
      this.controls.findIndex((control) => control.getAttribute('aria-expanded') === 'true'),
    )
  }

  disconnectedCallback() {
    this.abortController?.abort()
    this.abortController = null
    this.controls = []
    this.panels = []
  }

  handleClick = (event) => {
    this.select(this.controls.indexOf(event.currentTarget))
  }

  handleKeydown = (event) => {
    const current = this.controls.indexOf(event.currentTarget)
    if (current < 0) return

    let next = current
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight')
      next = (current + 1) % this.controls.length
    if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      next = (current - 1 + this.controls.length) % this.controls.length
    }
    if (event.key === 'Home') next = 0
    if (event.key === 'End') next = this.controls.length - 1
    if (next === current) return

    event.preventDefault()
    this.controls[next]?.focus?.()
    this.select(next)
  }

  handleBlockSelect = (event) => {
    const control = this.controls.find(
      (candidate) => candidate.dataset.shopifyEditorBlock === event.detail?.blockId,
    )
    if (control) this.select(this.controls.indexOf(control))
  }

  select(index) {
    const selected = index >= 0 ? index : 0
    this.controls.forEach((control, controlIndex) => {
      const active = controlIndex === selected
      control.classList.toggle('open', active)
      control.setAttribute('aria-expanded', String(active))
    })
    this.panels.forEach((panel, panelIndex) => {
      const active = panelIndex === selected
      panel.classList.toggle('active', active)
      panel.hidden = !active
    })
  }
}

if (globalThis.customElements && !globalThis.customElements.get('lp-three-d-switch')) {
  globalThis.customElements.define('lp-three-d-switch', ThreeDContentSwitch)
}
